import { Accounting } from "../gateway/Accounting/Accounting";

const ALLOWED_INTEGRATION_SYSTEMS = ["Omie", "Dominio"];

export class AccountingUpdateIntegrationSystemUsecase {
    constructor() {
        this.AccountingGateway = new Accounting();
    }

    async execute({ accountingId = "", system = "", connected = false } = {}) {
        const payload = this.sanitizeInput({
            accountingId,
            system,
            connected
        });
        if (!payload.accountingId) return null;
        if (!ALLOWED_INTEGRATION_SYSTEMS.includes(payload.system)) {
            throw new Error(
                "Sistema de integração inválido. Use Omie ou Dominio."
            );
        }
        const accounting = {
            _id: payload.accountingId,
            integrations: {
                [payload.system]: { connected: payload.connected }
            }
        };
        return await this.AccountingGateway.updateMany({
            accountings: [accounting]
        });
    }

    sanitizeInput({ accountingId = "", system = "", connected = false } = {}) {
        return {
            accountingId: String(accountingId).trim(),
            system: String(system).trim(),
            connected: Boolean(connected)
        };
    }
}
